module.exports = "/images/search.svg?cc1b12fb7d10438e07425f0338ae7701";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/search.svg
// module id = 84
// module chunks = 1